import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || '/api';

const api = axios.create({
  baseURL: API_URL
});

// Intercepteur pour ajouter le token
api.interceptors.request.use(
  (config) => {
    // Récupérer le token depuis le store Zustand
    const authStorage = localStorage.getItem('auth-storage');
    if (authStorage) {
      try {
        const { state } = JSON.parse(authStorage);
        if (state?.token) {
          config.headers.Authorization = `Bearer ${state.token}`;
        }
      } catch (error) {
        console.error('Erreur parsing auth-storage:', error);
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Intercepteur pour gérer les erreurs
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Nettoyer le localStorage
      localStorage.removeItem('auth-storage');
      
      // Rediriger vers la page de login appropriée
      const currentPath = window.location.pathname;
      if (currentPath.startsWith('/contributor')) {
        window.location.href = '/contributor/login';
      } else {
        window.location.href = '/admin/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
